import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import Paths from "./Paths";
import { useSelector } from "react-redux";
import SpinPage from "../pages/SpinPage";
import ClaimPage from "../pages/ClaimPage";
import CongraPage from "../pages/CongraPage";
import AdminValidatePage from "../pages/AdminValidatePage";
import AdminClaimPage from "../pages/AdminClaimPage";

const AppRouter = () => {
  const { user } = useSelector((state) => state.user);

  return (
    <BrowserRouter>
      {/* {!user ? (
        <Routes>
          <Route path="*" element={<LoginPage />} />
        </Routes>
      ) : ( */}
      <Routes>
        <Route path={Paths.home} element={<HomePage />} />
        <Route path={Paths.spin} element={<SpinPage />} />
        <Route path={Paths.claim} element={<ClaimPage />} />
        <Route path={Paths.congra} element={<CongraPage />} />
        <Route path={Paths.adminValidate} element={<AdminValidatePage />} />
        <Route path={Paths.adminClaim} element={<AdminClaimPage />} />
      </Routes>
      {/* )} */}
    </BrowserRouter>
  );
};

export default AppRouter;
